import { signal } from '@angular/core';

import { BaseModel } from '../../core/abstractions/base.model';
import { ControllerService } from '../../services/controller.service';
import { OptionalType } from '../types/optional.type';
import { RelatedItemModel } from './related-item.model';

export class ActionButtonModel extends BaseModel {
    icon: string;
    beforeClickFunction?: (btn: ActionButtonModel) => void;
    clickFunction?: any;
    color: string;
    iconClasses = signal<string[]>([]);
    iconColor?: string;
    caption: string;
    isDisabled: boolean;
    loadingRequestIcon = 'autorenew';
    loadingRequestIconClasses = ['sl-spin'];
    responseAction?: (
        btn: ActionButtonModel,
        item: RelatedItemModel,
        data: OptionalType<any>,
        controllerService: ControllerService
    ) => void;
    dialogClosedAction?: (btn: ActionButtonModel, parameters: any) => void;

    set isLoading(value: boolean) {
        if (value) {
            this.icon = this.loadingRequestIcon;
            this.iconClasses.set(this.loadingRequestIconClasses);
        } else {
            this.icon = this.originalIcon;
            this.iconClasses.set(this.originalIconClasses);
        }
    }

    private originalIcon: string;
    private originalIconClasses: string[];

    constructor(init?: Partial<ActionButtonModel>) {
        super();
        Object.assign(this, init);

        this.originalIcon = this.icon;
        this.originalIconClasses = this.iconClasses();
    }

    withRelated(relatedItem: RelatedItemModel): ActionButtonModel {
        const cmd = relatedItem.getCommand();
        if (!!cmd) {
            Object.assign(this, cmd.button);
        }

        if (!!relatedItem.displayName) {
            this.caption = relatedItem.displayName;
        }

        return this;
    }

    withAction(action: any): ActionButtonModel {
        this.clickFunction = action;
        return this;
    }
}
